import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers } from "./../../../component/common/AparEmployeeHeader";
import { getPersonalAttributeMasterList, getPersonalAttributeGrade } from "./../../../actions/AppraisalCycleAction";

class aparAcceptingManagerForm3 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      kpiReportId: null,
      personalAttributes: [] as any[],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Acceptance Authority - Personal Attributes - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { kpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, kpiReportId, showLoader: true });

    getPersonalAttributeMasterList().then((res: any) => {
      const masterList = res?.result || res || [];
      const sorted = [...masterList].sort((a: any, b: any) => (a.sort_order || 0) - (b.sort_order || 0));
      const personalAttributes = sorted.map((m: any) => ({
        attributeMasterId: m.id,
        name: m.attribute_name,
        repGrade: '',
        revGrade: '',
      }));

      this.setState({ personalAttributes }, () => {
        if (kpiReportId) {
          this.loadAttributeGrades(kpiReportId, "reporting", "repGrade", () => {
            this.loadAttributeGrades(kpiReportId, "reviewing", "revGrade", () => {
              this.setState({ showLoader: false });
            });
          });
        } else {
          this.setState({ showLoader: false });
        }
      });
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  }

  loadAttributeGrades = (kpiReportId: any, role: string, field: string, callback: () => void) => {
    getPersonalAttributeGrade({ kpiReportId, gradedByRole: role }).then((res: any) => {
      const data = res?.result || res;
      const grades = data?.grades || (Array.isArray(data) ? data : []);

      if (grades.length > 0) {
        const gradeMap: any = {};
        grades.forEach((g: any) => { gradeMap[g.attribute_master_id] = g; });

        const personalAttributes = this.state.personalAttributes.map((attr: any) => {
          const existing = gradeMap[attr.attributeMasterId];
          return existing ? { ...attr, [field]: String(existing.grade || '') } : attr;
        });

        this.setState({ personalAttributes }, callback);
      } else {
        callback();
      }
    }).catch(() => {
      callback();
    });
  };

  calculateRepAttrTotal = () => this.state.personalAttributes.reduce((sum: number, a: any) => sum + (parseFloat(a.repGrade) || 0), 0);
  calculateRevAttrTotal = () => this.state.personalAttributes.reduce((sum: number, a: any) => sum + (parseFloat(a.revGrade) || 0), 0);

  onNext = () => {
    const { employeeData, kpiReportId } = this.state;
    this.props.history.push({
      pathname: CONSTANT.component.aparAcceptingManagerForm2.url,
      state: {
        ...employeeData,
        kpiReportId,
      },
    });
  };

  render() {
    const { showLoader, employeeData, personalAttributes } = this.state;

    const repAttrTotal = this.calculateRepAttrTotal();
    const revAttrTotal = this.calculateRevAttrTotal();

    const ROMAN = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Acceptance Authority - Personal Attributes</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="accepting" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {!showLoader && (
                  <div>
                    <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                      Assessment of Personal Attributes and Functional Competencies
                      <small className="text-muted fw-normal ms-2">(Weightage: 25%)</small>
                    </h2>

                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: '8%' }}>S. No.</th>
                            <th style={{ width: '37%' }}>Personal Attributes and Functional Competencies</th>
                            <th style={{ width: '20%' }} className="text-center">Grade by Reporting Authority</th>
                            <th style={{ width: '20%' }} className="text-center">Grade by Reviewing Authority</th>
                          </tr>
                        </thead>
                        <tbody>
                          {personalAttributes.map((attr: any, index: number) => (
                            <tr key={attr.attributeMasterId}>
                              <td>{ROMAN[index] || index + 1}</td>
                              <td>{attr.name}</td>
                              <td className="text-center">{attr.repGrade || '—'}</td>
                              <td className="text-center">{attr.revGrade || '—'}</td>
                            </tr>
                          ))}
                          <tr className="table-light fw-semibold">
                            <td colSpan={2} className="text-end pe-3">Total (i to x)</td>
                            <td className="text-center">{repAttrTotal > 0 ? repAttrTotal.toFixed(2) : '—'}</td>
                            <td className="text-center">{revAttrTotal > 0 ? revAttrTotal.toFixed(2) : '—'}</td>
                          </tr>
                          <tr className="table-secondary fw-bold">
                            <td colSpan={2} className="text-end pe-3">Overall Grading (Total / 4)</td>
                            <td className="text-center">{repAttrTotal > 0 ? (repAttrTotal / 4).toFixed(2) : '—'}</td>
                            <td className="text-center">{revAttrTotal > 0 ? (revAttrTotal / 4).toFixed(2) : '—'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                        Back
                      </button>
                      <button type="button" className="btn btn-primary" onClick={this.onNext}>
                        Next <i className="fa fa-arrow-right ml-1" />
                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparAcceptingManagerForm3);
